import { render, staticRenderFns } from "./ConfigHistory.vue?vue&type=template&id=d426a9d0&scoped=true&"
import script from "./ConfigHistory.vue?vue&type=script&lang=js&"
export * from "./ConfigHistory.vue?vue&type=script&lang=js&"
import style0 from "./ConfigHistory.vue?vue&type=style&index=0&id=d426a9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d426a9d0",
  null
  
)

export default component.exports